import { defineStore } from 'pinia'
import { useApi } from '@/shared/composables'
import type { TravelerInformation } from '@/shared/types/api.types'

export const useTravelersStore = defineStore('travelersStore', {
  actions: {
    async getTravelers(): Promise<TravelerInformation[]> {
      const api = useApi()
      return await api.travelerService.getTravelers()
    },
    async saveTraveler(information: TravelerInformation) {
      const api = useApi()
      return await api.travelerService.saveTraveler(information)
    },
    async deleteTraveler(srNo: string) {
      const api = useApi()
      return await api.travelerService.deleteTraveler(srNo)
    },
    async updateTravelInfo(quoteno: string) {
      const api = useApi()
      return await api.travelerService.updateTravelInfo(quoteno)
    },
  },
})
